import { createConsumer } from '@rails/actioncable';

// AIDEV-NOTE: ActionCable consumer for WebSocket connections via AnyCable.
// Dev: ws://localhost:8080/cable (AnyCable-Go). Prod: /cable (ALB → AnyCable-Go).
// The URL is auto-detected from the action_cable meta tag or action_cable.url config.
const consumer = createConsumer();

export default consumer;

// AIDEV-NOTE: Dev-only. Firefox/Chrome offline modes leave loopback sockets open, so simulate a
// drop from the console: cableConsumer.disconnect() (stops reconnects too) / cableConsumer.connect().
if (process.env.NODE_ENV === 'development') {
  (window as unknown as { cableConsumer?: typeof consumer }).cableConsumer = consumer;
}
